import type { SxProps, Theme } from '@mui/material/styles';

import { signupPageStyles, signupTypography } from '../../../pages/signup/SignupPage/SignupPage.styles';

export const signupResultLayoutStyles = {
  page: signupPageStyles.page,
  content: signupPageStyles.content,
  logoHeader: signupPageStyles.logoHeader,
  logo: signupPageStyles.logo,
  title: signupPageStyles.title,
  resultPanel: (theme: Theme): SxProps<Theme> => ({
    width: '100%',
    maxWidth: '620px',
    mx: 'auto',
    mt: { xs: 7, sm: 11 },
    p: { xs: 3, sm: 5 },
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 2,
  }),
  resultMessage: (theme: Theme): SxProps<Theme> => ({
    mt: 2,
    color: theme.palette.grey[700],
    fontSize: signupTypography.standard,
    lineHeight: 1.55,
  }),
  resultActions: (): SxProps<Theme> => ({
    display: 'flex',
    gap: 2,
    mt: 4,
    flexWrap: 'wrap',
    '& .MuiButton-root': {
      fontSize: signupTypography.standard,
    },
  }),
  inlineResult: (): SxProps<Theme> => ({
    mt: 3,
  }),
};
